import "../../styles/menu.scss";
import React, { useEffect } from "react";
import { ClientProviderEnum } from "../../constants/index.js";
import SearchMenuSection from "../Menu/Search/SearchMenuSection.js";
import TopMenuSection from "../Menu/TopMenuSection/TopMenuSection.js";
import HomeSection from "../../segmentedComponents/HomeSection/index.js";
import CategoriesMobile from "../Menu/Categories/CategoriesMobile.js";
import RegulationLogosSection from "../../segmentedComponents/RegulationLogosSection/index.js";
import SecondaryMenu from "../../segmentedComponents/SecondaryMenu/index.js";
import { useSelector } from "react-redux";
import { SearchSelectors } from "../../redux/selectors/index.js";
import { BrandUtils } from "../../utils/brandUtils.js";
import { useDispatch } from "react-redux";
import { MenuActionCreators } from "../../redux/action-creators/index.js";
import { PageContextUtils, ThemeUtils } from "../../utils/index.js";
import { MobileCrossActivity } from "../../segmentedComponents/CrossActivity/loader.js";
import {
  HamburgerMenuMobileWrapper,
  HamburgerMenuMobileHomeSectionWrapper
} from "./components/HamburgerMenuMobileWrapper.js";

const HamburgerMenuMobile = () => {
  const dispatch = useDispatch();
  const searchActive = useSelector(SearchSelectors.searchActive);
  const { name } = PageContextUtils.getClientProviderData();

  useEffect(() => {
    setTimeout(() => {
      dispatch(MenuActionCreators.setDrawersRendering(false));
      dispatch(MenuActionCreators.setDrawersLoaded(true));
    }, 250);
  }, [dispatch]);

  return (
    <HamburgerMenuMobileWrapper data-testid={"uc-hamburger-menu"}>
      {!searchActive && <MobileCrossActivity />}
      {name === ClientProviderEnum.Kambi && <SearchMenuSection />}
      <div
        className={`searchAnimation${searchActive ? " animationStart" : ""}`}
      >
        {ThemeUtils.isMrGreenTheme() ? (
          <>
            {name === ClientProviderEnum.Spectate && <SearchMenuSection />}
            <TopMenuSection />
          </>
        ) : (
          <>
            <TopMenuSection />
            {name === ClientProviderEnum.Spectate && <SearchMenuSection />}
          </>
        )}
        <HamburgerMenuMobileHomeSectionWrapper>
          <HomeSection />
        </HamburgerMenuMobileHomeSectionWrapper>
        {!BrandUtils.isPokerClient() && <CategoriesMobile />}
        <RegulationLogosSection showControlCenter={true} />
        <SecondaryMenu />
      </div>
    </HamburgerMenuMobileWrapper>
  );
};

export default React.memo(HamburgerMenuMobile);
